const Modal = {

  showOkModal: function(title, msg) {
    let window = $('#ok-modal');
    window.find('.modal-title').html(title);
    window.find('.modal-body').html(msg);
    window.modal();
  },

  showErrorModal: function(title, msg) {
    let window = $('#error-modal');

    if(typeof title === "undefined" || title == '') {
      title = 'Unknown title'
    }

    if(typeof msg === "undefined" || msg == '') {
      msg = 'Unknown message'
    }

    window.find('.modal-title').html(title);
    window.find('.modal-body').html(msg);

    window.modal();
  }

};

export default Modal;
